/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContentManagementCreateContentRequest } from '../models/ContentManagementCreateContentRequest';
import type { ContentManagementCreateContentResponseApiRespoonse } from '../models/ContentManagementCreateContentResponseApiRespoonse';
import type { ContentManagementDeleteContentByFileNameRequest } from '../models/ContentManagementDeleteContentByFileNameRequest';
import type { ContentManagementDeleteContentByFileNameResponseApiRespoonse } from '../models/ContentManagementDeleteContentByFileNameResponseApiRespoonse';
import type { ContentManagementDeleteContentRequest } from '../models/ContentManagementDeleteContentRequest';
import type { ContentManagementDeleteContentResponseApiRespoonse } from '../models/ContentManagementDeleteContentResponseApiRespoonse';
import type { ContentManagementGetTokenRequest } from '../models/ContentManagementGetTokenRequest';
import type { ContentManagementGetTokenResponseApiRespoonse } from '../models/ContentManagementGetTokenResponseApiRespoonse';
import type { ContentManagementListContentRequest } from '../models/ContentManagementListContentRequest';
import type { ContentManagementListContentResponseApiRespoonse } from '../models/ContentManagementListContentResponseApiRespoonse';
import type { ContentManagementRetryCreateContentRequest } from '../models/ContentManagementRetryCreateContentRequest';
import type { ContentManagementRetryCreateContentResponseApiRespoonse } from '../models/ContentManagementRetryCreateContentResponseApiRespoonse';
import type { ContentManagementUpdateContentRequest } from '../models/ContentManagementUpdateContentRequest';
import type { ContentManagementUpdateContentResponseApiRespoonse } from '../models/ContentManagementUpdateContentResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ContentsManagerService {

    /**
     * Create Content
     * @param requestBody
     * @returns ContentManagementCreateContentResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminContentsCreate(
        requestBody: ContentManagementCreateContentRequest,
    ): CancelablePromise<ContentManagementCreateContentResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contents/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Retry Create Content
     * @param requestBody
     * @returns ContentManagementRetryCreateContentResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminContentsRetryCreate(
        requestBody: ContentManagementRetryCreateContentRequest,
    ): CancelablePromise<ContentManagementRetryCreateContentResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contents/retry-create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Delete Content
     * @param requestBody
     * @returns ContentManagementDeleteContentResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminContentsDelete(
        requestBody: ContentManagementDeleteContentRequest,
    ): CancelablePromise<ContentManagementDeleteContentResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/contents/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Delete Content
     * @param requestBody
     * @returns ContentManagementDeleteContentByFileNameResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminContentsDeleteByFileName(
        requestBody: ContentManagementDeleteContentByFileNameRequest,
    ): CancelablePromise<ContentManagementDeleteContentByFileNameResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/contents/delete-by-file-name',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Get list Contents
     * @param requestBody
     * @returns ContentManagementListContentResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminContents(
        requestBody: ContentManagementListContentRequest,
    ): CancelablePromise<ContentManagementListContentResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contents',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * get token
     * @param requestBody
     * @returns ContentManagementGetTokenResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminContentsConnectSocketUrl(
        requestBody: ContentManagementGetTokenRequest,
    ): CancelablePromise<ContentManagementGetTokenResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/contents/connect-socket-url',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Update Content
     * @param requestBody
     * @returns ContentManagementUpdateContentResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminContentsUpdate(
        requestBody: ContentManagementUpdateContentRequest,
    ): CancelablePromise<ContentManagementUpdateContentResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/contents/update',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
